import { render, staticRenderFns } from "./classicCasesDetail.vue?vue&type=template&id=65bebd7c&scoped=true&"
import script from "./classicCasesDetail.vue?vue&type=script&lang=js&"
export * from "./classicCasesDetail.vue?vue&type=script&lang=js&"
import style0 from "./classicCasesDetail.vue?vue&type=style&index=0&id=65bebd7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bebd7c",
  null
  
)

export default component.exports